import { Link } from "react-router";

import { pathsSchema } from "shell/platform/config/paths";

import type { MenuItem, MenuTranslator } from "../types";

type DeprecationMenuEntry = {
  key: string;
  path: string;
  label: (t: MenuTranslator) => string;
};

const SMART_CLIENT_DEPRECATION_MENU: DeprecationMenuEntry[] = [
  {
    key: "mcc-padding",
    path: pathsSchema.smartClientDeprecation.mccPadding,
    label: t => t("common:labels.mccPadding"),
  },
  {
    key: "xml-file-details",
    path: pathsSchema.smartClientDeprecation.xmlFileDetails,
    label: t => t("clientLifecycle:xmlFileDetails.xmlFileDetails"),
  },
  {
    key: "web-service-fee-master",
    path: pathsSchema.smartClientDeprecation.webServiceFeeMaster,
    label: t => t("clientLifecycle:webServiceFeeMaster.webServiceFeeMaster"),
  },
  {
    key: "fees-master",
    path: pathsSchema.smartClientDeprecation.feesMaster,
    label: t => t("clientLifecycle:feesMaster.feesMaster"),
  },
  {
    key: "web-service-fees-by-group",
    path: pathsSchema.smartClientDeprecation.webServiceFeesByGroup,
    label: t =>
      t("clientLifecycle:webServiceFeesByGroup.webServiceFeesByGroup"),
  },
  {
    key: "recurring-fee-sub-group-master",
    path: pathsSchema.smartClientDeprecation.recurringFeeSubGroupMaster,
    label: t =>
      t(
        "clientLifecycle:recurringFeeSubGroupMaster.recurringFeeSubGroupMaster",
      ),
  },
  {
    key: "group-fee-recurring-master",
    path: pathsSchema.smartClientDeprecation.groupFeeRecurringMaster,
    label: t =>
      t("clientLifecycle:groupFeeRecurringMaster.groupFeeRecurringMaster"),
  },
  {
    key: "group-recurring-fees",
    path: pathsSchema.smartClientDeprecation.groupRecurringFees,
    label: t => t("clientLifecycle:groupRecurringFees.groupRecurringFees"),
  },
  {
    key: "fees-by-group",
    path: pathsSchema.smartClientDeprecation.feesByGroup,
    label: t => t("clientLifecycle:feesByGroup.feesByGroup"),
  },
  {
    key: "bank-master",
    path: pathsSchema.smartClientDeprecation.bankMaster,
    label: t => t("clientLifecycle:labels.bankMaster"),
  },
  {
    key: "bank",
    path: pathsSchema.smartClientDeprecation.bank,
    label: t => t("clientLifecycle:labels.bank"),
  },
  {
    key: "program-manager-master",
    path: pathsSchema.smartClientDeprecation.programManagerMaster,
    label: t => t("clientLifecycle:programManagerMaster.programManagerMaster"),
  },
  {
    key: "institution-master",
    path: pathsSchema.smartClientDeprecation.institutionMaster,
    label: t => t("clientLifecycle:institutionMaster.institutionMaster"),
  },
  {
    key: "scheme-master",
    path: pathsSchema.smartClientDeprecation.schemeMaster,
    label: t => t("clientLifecycle:labels.schemeMaster"),
  },
  {
    key: "fraud-and-risk-configurations",
    path: pathsSchema.smartClientDeprecation.fraudAndRiskConfigurations,
    label: t =>
      t(
        "clientLifecycle:fraudAndRiskConfigurations.fraudAndRiskConfigurations",
      ),
  },
  {
    key: "product-export",
    path: pathsSchema.smartClientDeprecation.productExport,
    label: t => t("clientLifecycle:productExport.productExport"),
  },
  {
    key: "product-import",
    path: pathsSchema.smartClientDeprecation.productImport,
    label: t => t("clientLifecycle:productImport.productImport"),
  },
  {
    key: "institution-export",
    path: pathsSchema.smartClientDeprecation.institutionExport,
    label: t => t("clientLifecycle:institutionExport.institutionExport"),
  },
  {
    key: "product-master",
    path: pathsSchema.smartClientDeprecation.productMaster,
    label: t => t("clientLifecycle:productMaster.productMaster"),
  },
  {
    key: "mcc-code-master",
    path: pathsSchema.smartClientDeprecation.mccCodeMaster,
    label: t => t("clientLifecycle:mccCodeMaster.mccCodeMaster"),
  },
  {
    key: "currency-master",
    path: pathsSchema.smartClientDeprecation.currencyMaster,
    label: t => t("clientLifecycle:currencyMaster.currencyMaster"),
  },
  {
    key: "load-source-master",
    path: pathsSchema.smartClientDeprecation.loadSourceMaster,
    label: t => t("clientLifecycle:loadSourceMaster.loadSourceMaster"),
  },
  {
    key: "group-limit",
    path: pathsSchema.smartClientDeprecation.groupLimit,
    label: t => t("clientLifecycle:labels.groupLimit"),
  },
  {
    key: "group-limit-master",
    path: pathsSchema.smartClientDeprecation.groupLimitMaster,
    label: t => t("clientLifecycle:groupLimitMaster.groupLimitMaster"),
  },
  {
    key: "mcc-group-master",
    path: pathsSchema.smartClientDeprecation.mccGroupMaster,
    label: t => t("clientLifecycle:mccGroupMaster.mccGroupMaster"),
  },
  {
    key: "mcc-group",
    path: pathsSchema.smartClientDeprecation.mccGroup,
    label: t => t("clientLifecycle:mccGroup.groupMccSettings"),
  },
  {
    key: "usage-group-master",
    path: pathsSchema.smartClientDeprecation.usageGroupMaster,
    label: t => t("clientLifecycle:usageGroupMaster.usageGroupMaster"),
  },
  {
    key: "usage-group-rules-details",
    path: pathsSchema.smartClientDeprecation.usageGroupRulesDetails,
    label: t =>
      t("clientLifecycle:usageGroupRulesDetails.usageGroupRulesDetails"),
  },
  {
    key: "group-card-linkage",
    path: pathsSchema.smartClientDeprecation.groupCardLinkage,
    label: t => t("clientLifecycle:groupCardLinkage.groupCardLinkage"),
  },
  {
    key: "card-acceptor-list-master",
    path: pathsSchema.smartClientDeprecation.cardAcceptorListMaster,
    label: t => t("clientLifecycle:cardAcceptorList.cardAcceptorListMaster"),
  },
  {
    key: "card-acceptor-list-card-acceptor-master",
    path: pathsSchema.smartClientDeprecation.cardAcceptorListCardAcceptor,
    label: t =>
      t("clientLifecycle:cardAcceptorList.cardAcceptorListCardAcceptor"),
  },
  {
    key: "card-disallow-list-master",
    path: pathsSchema.smartClientDeprecation.cardDisallowListMaster,
    label: t => t("clientLifecycle:cardAcceptorList.cardDisallowListMaster"),
  },
  {
    key: "card-disallow-list-card-acceptor",
    path: pathsSchema.smartClientDeprecation.cardDisallowListCardAcceptor,
    label: t =>
      t("clientLifecycle:cardAcceptorList.cardDisallowListCardAcceptor"),
  },
];

export const buildSmartClientDeprecationChildren = (
  t: MenuTranslator,
): MenuItem[] =>
  SMART_CLIENT_DEPRECATION_MENU.map(({ key, path, label }) => ({
    key,
    label: <Link to={path}>{label(t)}</Link>,
  }));
